import { GetterTree } from 'vuex';
import { StateInterface } from '@/interfaces/projects';
import { feedbackDetails } from '@/interfaces/feedback';


const getters: GetterTree<feedbackDetails, StateInterface> = {
    // someGetter( /* state */ ) {
    //     // return true;
    // },
    // projectId(state) {
    //     return state.projectId;
    // },
    // getEntriesByTerm ( state ) => ( term = '' ) => {

    //     if ( term.length === 0 ) return state.projects
    
    //     return state.entries.filter( entry => entry.text.toLowerCase().includes( term.toLocaleLowerCase() ) )
    // }
    getEnvios( state) {
        return state.envios;
    },
    getFicheros(state) {
        return state.ficheros;
    },
    getId(state) {
        return state.id;
    },
    getNombre(state) {
        return state.nombre;
    },
}



export default getters;